(function () {
  'use strict';

  var DISCOUNT_CODE = 'FIRSTORDER';
  var EVENT_SOURCE = 'casidor-subscription-first-order-discount';
  var syncPromise = null;
  var rerunRequested = false;
  var checkoutBypass = false;

  function cartRoute(path) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + path;
  }

  function getCart() {
    return fetch(cartRoute('cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function hasSubscriptionItem(cart) {
    return cart.items.some(function (item) {
      return Boolean(item.selling_plan_allocation);
    });
  }

  function hasSelectedSubscription() {
    return Array.from(document.querySelectorAll('[name="selling_plan"]')).some(function (field) {
      if (field.disabled) return false;
      if (field.type === 'radio' || field.type === 'checkbox') {
        return field.checked && Boolean(field.value);
      }
      return Boolean(field.value);
    });
  }

  function currentDiscountCodes(cart) {
    return (cart.discount_codes || []).map(function (discount) {
      return discount.code;
    }).filter(Boolean);
  }

  function desiredDiscountCodes(cart) {
    var codes = currentDiscountCodes(cart).filter(function (code) {
      return code.toUpperCase() !== DISCOUNT_CODE;
    });

    if (hasSubscriptionItem(cart) || hasSelectedSubscription()) {
      codes.push(DISCOUNT_CODE);
    }

    return codes;
  }

  function codesMatch(currentCodes, desiredCodes) {
    if (currentCodes.length !== desiredCodes.length) return false;

    return currentCodes.every(function (code) {
      return desiredCodes.some(function (desiredCode) {
        return desiredCode.toUpperCase() === code.toUpperCase();
      });
    });
  }

  function updateDiscounts(codes) {
    return fetch(cartRoute('cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to update cart discount');
      return response.json();
    });
  }

  function publishCartUpdate(cart) {
    var cartDrawer = document.querySelector('m-cart-drawer');
    if (cartDrawer && typeof cartDrawer.onCartDrawerUpdate === 'function') {
      cartDrawer.onCartDrawerUpdate(true);
    }

    if (!window.MinimogEvents || !window.MinimogTheme || !MinimogTheme.pubSubEvents) return;

    window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
      source: EVENT_SOURCE,
      cart: cart
    });
  }

  function runSync() {
    return getCart().then(function (cart) {
      var currentCodes = currentDiscountCodes(cart);
      var desiredCodes = desiredDiscountCodes(cart);

      if (codesMatch(currentCodes, desiredCodes)) return cart;

      return updateDiscounts(desiredCodes).then(function (updatedCart) {
        publishCartUpdate(updatedCart);
        return updatedCart;
      });
    });
  }

  function syncDiscount() {
    if (syncPromise) {
      rerunRequested = true;
      return syncPromise;
    }

    syncPromise = runSync()
      .catch(function () {
        return null;
      })
      .finally(function () {
        syncPromise = null;
        if (rerunRequested) {
          rerunRequested = false;
          syncDiscount();
        }
      });

    return syncPromise;
  }

  function scheduleSync() {
    window.clearTimeout(scheduleSync.timer);
    scheduleSync.timer = window.setTimeout(syncDiscount, 50);
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('[name="selling_plan"]')) scheduleSync();
  });

  document.addEventListener('submit', function (event) {
    var submitter = event.submitter;
    if (checkoutBypass || !submitter || submitter.name !== 'checkout') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    syncDiscount().finally(function () {
      checkoutBypass = true;
      submitter.form.requestSubmit(submitter);
      window.setTimeout(function () {
        checkoutBypass = false;
      }, 0);
    });
  }, true);

  document.addEventListener('click', function (event) {
    var checkoutLink = event.target.closest && event.target.closest('a[href*="/checkout"]');
    if (!checkoutLink || checkoutLink.dataset.firstOrderDiscountReady === 'true') return;

    event.preventDefault();
    syncDiscount().finally(function () {
      checkoutLink.dataset.firstOrderDiscountReady = 'true';
      window.location.assign(checkoutLink.href);
    });
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    syncDiscount();

    if (window.MinimogEvents && window.MinimogTheme && MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, function (payload) {
        if (!payload || payload.source !== EVENT_SOURCE) scheduleSync();
      });
    }
  });
})();
